import api from '../../services/service_income'
import Swal from 'sweetalert2'
import moment from 'moment'
import '../../../static/fontawesome-5.10.2/css/all.css'

export default {
  data () {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      home_data: [],
      water_data: [],
      year: moment(new Date()).format('YYYY'),
      year_select: moment(new Date()).format('YYYY'),
      
    }
  },
  created () {
    this.checkUser()
  },
  methods: {
    getIncome () {
      this.$store.state.isLoading = true
      api.IncomeDetail(this.$route.params.id,
        this.header,
        result => {
          if (result.response === true) {
            this.home_data = result.data
            this.getWater(this.home_data.home_id)
          } else {
            Swal.fire('ดึงข้อมูลหนี้สินรายเดือน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getWater (homeId) {
      this.$store.state.isLoading = true
      var obj = {
        home_id: homeId,
        year: this.year_select
      }
      api.getWaterHistoryPost(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.water_data = result.data
          } else {
            Swal.fire('ดึงข้อมูลประวัติการใช้น้ำ', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    addWater () {
      this.home_data.water_income.push(
        {
          water_income_id: '',
          water_income_text: 'มิเตอร์ที่ ' + (this.home_data.water_income.length + 1),
          water_income_unit: 0,
          water_total_last_unit: 0,
          water_income_price: 0,
          history_income_id: this.home_data.history_income_id
        }

      )
    },
    removeWater (index) {
      this.home_data.water_income.splice(index, 1)
    },
    addOther () {
      this.home_data.other_income.push(
        {
          other_income_id: '',
          income_detail: '',
          price: '',
          history_income_id: this.home_data.history_income_id
        }
      )
    },
    removeOther (index) {
      this.home_data.other_income.splice(index, 1)
    },
    checkWater (index) {
      var last = this.home_data.water_income[index]['water_total_last_unit']
      var current = this.home_data.water_income[index]['water_income_unit']
      const limit = this.home_data.water_income[index]['limit_water_unit']
      if (parseInt(last) > parseInt(current)) {
        Swal.fire('กรอกข้อมูลน้ำ', 'ท่านต้องกรอกยอดมิตเตอร์ให้มากกว่ายอดเดิม', 'warning')
        this.home_data.water_income[index]['water_income_unit'] = this.home_data.water_income[index]['water_total_last_unit']
      }

      if ((parseInt(current) - parseInt(last)) > parseInt(limit)) {
        Swal.fire({
          title: 'กรอกข้อมูลน้ำ',
          text: 'ท่านต้องกรอกยอดมิตเตอร์เกินกำหนด ท่านต้องการใช้ยอดที่กรอกเข้ามาหรือไม่ ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            this.home_data.water_income[index]['water_income_unit'] = this.home_data.water_income[index]['water_income_unit']
          } else {
            this.home_data.water_income[index]['water_income_unit'] = ''
          }
        })
      }
    },
    save () {
      this.$store.state.isLoading = true
      api.updateIncome(this.home_data,
        this.header,
        result => {
          if (result.response === true) {
            Swal.fire('บันทึกข้อมูลหนี้สินรายเดือน', result.data, 'success')
            this.getIncome()
          } else {
            Swal.fire('บันทึกข้อมูลหนี้สินรายเดือน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getIncome()
    // eslint-disable-next-line no-undef
    $('body').on('hidden.bs.modal', '.modal', function () {
      // eslint-disable-next-line no-undef
      $(this).removeData('bs.modal')
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/formincome.js